<script lang="ts">
	import '../../app.css';

	import type { Snippet } from 'svelte';

	import { t, locale } from '$lib/translations';

	import { page, navigating } from '$app/state';

	let hasClipMask = $derived(![null, '/[locale=locale]', '/[locale=locale]/[photographs=photographs]/[year]/[month]/[day]/[slug]'].includes(page.route.id));

	import Header from './Header.svelte';
	import Footer from './Footer.svelte';

	interface Props {
		opening?: Snippet;
		children?: Snippet;
	}

	let { opening, children }: Props = $props();
</script>

<svelte:head>
	<meta name="robots" content="index,follow,max-image-preview:large" />
	<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
	<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
	<meta name="author" content="Silvano Stralla" />
	<meta name="theme-color" content="#333333" />
	<link rel="alternate" type="application/rss+xml" title={`sistrall.it — ${$t('feed.description')}`} href={`/${$locale}/feed.xml`} />
	<!--  Privacy-aware analytics: an instance of Plausible deployed via Dokku  -->
	<script defer data-domain="sistrall.it" src="https://analytics.sistrall.it/js/plausible.js"></script>
</svelte:head>

<div
	class={` bg-[length:200%_100%] transition-all duration-500 ${navigating.type ? 'from-dark-gray/100 to-dark-gray/100 via-medium-gray/100' : 'from-dark-gray/0 to-dark-gray/0 via-medium-gray/0'}`}
	class:animate-background-position={navigating.type}
	class:bg-gradient-to-l={navigating.type}
>
	<a class="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:z-0 focus:mx-2 font-sans text-white text-sm md:text-base focus:py-2" href="#page-content"
		>{$t('shared.skipToTheContent')}</a
	>
	<hr id="page-header" class="border-t-0" />

	<header class="font-sans uppercase text-white text-sm md:text-base sticky top-0 z-0">
		<Header />
	</header>

	<main id="page-content" class="bg-bridal-heath-50 rounded-t-md mx-2 mt-2 z-1 relative" class:has-clip-mask={hasClipMask}>
		{@render opening?.()}
		{@render children?.()}
	</main>

	<footer>
		<Footer />
	</footer>
</div>

<style>
	main {
		transition: mask-position 0.2s;
		mask-position: 0 0;

		& {
			mask-image: radial-gradient(circle 2.5rem at center -1.5rem, black, black);
		}
		&.has-clip-mask {
			mask-image: radial-gradient(circle 2.5rem at center -1.5rem, transparent, transparent 100%, black 102%, black);
		}
	}
</style>
